import React from "react";
import '../../styles/Sweeps.css';
const Pagination = (props) => {
    const { totalPages, handlePageChange, currentPage, handleViewAll, viewAll } = props;

    //Get page numbers to be displayed
    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxPagesToShow = 3;
        const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
        const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return pageNumbers;
    };

    return (
        <div className="pagination custom-padding-top sweeps">
            {viewAll ? (
                <a onClick={handleViewAll} className="view-all">Reset to Pagination View</a>
            ) : (
                <div >
                    <ul>
                        <li className={currentPage === 1 ? "disabled" : ""}>
                            <a aria-label="First" className="icon-chevron-double-left" onClick={() => handlePageChange(1)}></a>
                        </li>
                        <li className={currentPage === 1 ? "disabled" : ""}>
                            <a aria-label="Previous" className="icon-chevron-left" onClick={() => handlePageChange(currentPage - 1)}></a>
                        </li>
                        {getPageNumbers().map((pageNumber) => (
                            <li key={pageNumber} className={currentPage === pageNumber ? "pagination-active" : ""}>
                                <a onClick={() => handlePageChange(pageNumber)}>{pageNumber}</a>
                            </li>
                        ))}
                        <li className={currentPage === totalPages ? "disabled" : ""}>
                            <a aria-label="Next" className="icon-chevron-right" onClick={() => handlePageChange(currentPage + 1)}></a>
                        </li>
                        <li className={currentPage === totalPages ? "disabled" : ""}>
                            <a aria-label="Last" className="icon-chevron-double-right" onClick={() => handlePageChange(totalPages)}></a>
                        </li>
                    </ul>
                    <div className="pagination-pages">{totalPages} Pages<br />
                        <a onClick={handleViewAll} className="view-all">View All</a>
                    </div>
                </div>
            )}
        </div>
    );
};
export default Pagination;